import React from "react";
import { Row } from "react-bootstrap";
import vit from "../../assets/vit.png";
import modern from "../../assets/modern.png";
import InfoContainer from "./widgets/info_container";

const Techstack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <InfoContainer
        title="BTech - Computer Science & Engineering"
        description="Vellore Institute of Technology, Bhopal (2020- 2024)"
        type="CGPA:"
        number="8.97"
        imageSrc={vit}
      ></InfoContainer>

      <InfoContainer
        title="Higher Secondary (10+2)"
        description="Modern Public School, Ashta M.P (2019 - 2020)"
        type="Percentage:"
        number="91.6%"
        imageSrc={modern}
      ></InfoContainer>

      <InfoContainer
        title="Higher Secondary (10)"
        description="Modern Public School, Ashta M.P (2017 - 2018)"
        type="Percentage:"
        number="94.2%"
        imageSrc={modern}
      ></InfoContainer>
    </Row>
  );
};

export default Techstack;
